import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    Authorization: sessionStorage.getItem('Authorization')
      ? sessionStorage.getItem('Authorization')
      : '',
    userInfo: localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo'))
      : {
        Account: '',
        UserName: '',
        HeadPhoto: '',
        Identity: '',
        RoleType: '',
        Birthday: '',
      },
    hasLogin: false,
    systemInfo: sessionStorage.getItem('systemInfo')
      ? JSON.parse(sessionStorage.getItem('systemInfo'))
      : { CompanyLogo: '', CompanyNM: '', SystemNM: '' },
  },
  mutations: {
    setToken(state, token) {
      state.Authorization = token
      sessionStorage.setItem('Authorization', token)
    },
    removeToken(state) {
      state.Authorization = ''
      sessionStorage.removeItem('Authorization')
    },
    setSystemInfo(state, provider) {
      state.systemInfo.CompanyLogo = provider.CompanyLogo
      state.systemInfo.CompanyNM = provider.CompanyNM
      state.systemInfo.SystemNM = provider.SystemNM
      sessionStorage.setItem('systemInfo', JSON.stringify(state.systemInfo))
    },
    login(state, provider) {
      //改变登录状态
      state.hasLogin = true
      state.userInfo.Account = provider.UserID
      state.userInfo.UserName = provider.RealName
      state.userInfo.SourceNo = provider.SourceNo
      state.userInfo.Identity = provider.Show
      state.userInfo.HeadPhoto = provider.HeadPhoto ? provider.HeadPhoto : ''
      state.userInfo.RoleType =
        provider.roleDj == '2'
          ? '管理员'
          : provider.roleDj == '3'
            ? '咨询师'
            : provider.roleDj == '4'
              ? '来访者'
              : '超级管理员'
      state.userInfo.Birthday = provider.Birthday
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    logout(state) {
      //退出登录
      state.hasLogin = false
      state.userInfo = {}
      localStorage.removeItem('userInfo')
      state.systemInfo = {}
      localStorage.removeItem('systemInfo')
    },
  },
})

export default store
